<div class="mat-dialog-device-details">
    <form [formGroup]="deviceInputForm">
        <div mat-dialog-title class="dialog-title">
            <h2>{{headerName}}</h2>
            <button mat-icon-button aria-label="close dialog" mat-dialog-close>
                <mat-icon>close</mat-icon>
            </button>
        </div>
        <mat-dialog-content class="mat-typography">
            <div class="device-details-form">
                <mat-grid-list cols="2" rowHeight="80px">
                    <mat-grid-tile *ngIf="isAddButton">
                        <div class="w-100">
                            <mat-form-field appearance="outline" class="form-feild">
                                <mat-label>Device Type </mat-label>
                                <mat-select formControlName="deviceType"
                                    (ngModelChange)="handleSelectDeviceType($event)">
                                    <mat-option *ngFor="let deviceTyp of deviceTypsData;"
                                        value="{{deviceTyp.value}}">{{deviceTyp.name}}</mat-option>
                                </mat-select>
                                <mat-error *ngIf="deviceInputForm.invalid">
                                    {{errorMessageFormField.deviceType}}
                                </mat-error>
                            </mat-form-field>
                        </div>
                    </mat-grid-tile>
                    <mat-grid-tile>
                        <div class="w-100">
                            <mat-form-field appearance="outline" class="form-feild">
                                <mat-label>IP Address </mat-label>
                                <input matInput placeholder="IP Address" formControlName="ipAddress" />
                                <mat-error *ngIf="deviceInputForm.invalid">
                                    {{errorMessageFormField.ipAddress}}
                                </mat-error>
                            </mat-form-field>
                        </div>
                    </mat-grid-tile>
                    <mat-grid-tile *ngIf="isSecondaryIpAddress">
                        <div class="w-100">
                            <mat-form-field appearance="outline" class="form-feild">
                                <mat-label class="">Secondary IP Address </mat-label>
                                <input matInput placeholder="Secondary IP Address"
                                    formControlName="secondaryIpAddress" />
                                <mat-error *ngIf="deviceInputForm.invalid">
                                    {{errorMessageFormField.secondaryIpAddress}}
                                </mat-error>
                            </mat-form-field>
                        </div>
                    </mat-grid-tile>
                    <mat-grid-tile>
                        <div class="w-100">
                            <mat-form-field appearance="outline" class="form-feild">
                                <mat-label>User Name </mat-label>
                                <input matInput placeholder="User Name" formControlName="username" />
                                <mat-error *ngIf="deviceInputForm.invalid">
                                    {{errorMessageFormField.username}}
                                </mat-error>
                            </mat-form-field>
                        </div>
                    </mat-grid-tile>
                    <mat-grid-tile>
                        <div class="w-100">
                            <mat-form-field appearance="outline" class="form-feild">
                                <mat-label>Password </mat-label>
                                <input matInput placeholder="password" formControlName="password"
                                    [type]="hidePassword ? 'password' : 'text'" />
                                <mat-icon matSuffix (click)="hidePassword = !hidePassword">{{hidePassword ?
                                    'visibility_off' : 'visibility'}}</mat-icon>
                                <mat-error *ngIf="deviceInputForm.invalid">
                                    {{errorMessageFormField.password}}
                                </mat-error>
                            </mat-form-field>
                        </div>
                    </mat-grid-tile>
                    <mat-grid-tile *ngIf="!isAddButton">
                        <div class="w-100">
                            <mat-form-field appearance="outline" class="form-feild">
                                <mat-label>Unique ID </mat-label>
                                <input matInput placeholder="Unique ID" formControlName="uniqueID"
                                    readonly="{{!isAddButton}}" />
                                <mat-error *ngIf="deviceInputForm.invalid">
                                    {{errorMessageFormField.uniqueID}}
                                </mat-error>
                            </mat-form-field>
                        </div>
                    </mat-grid-tile>
                    <mat-grid-tile>
                        <div class="w-100">
                            <mat-form-field appearance="outline" class="form-feild">
                                <mat-label>MAC Address </mat-label>
                                <input matInput placeholder="MAC Address" formControlName="macAddress" />
                                <mat-error *ngIf="deviceInputForm.invalid">
                                    {{errorMessageFormField.macAddress}}
                                </mat-error>
                            </mat-form-field>
                        </div>
                    </mat-grid-tile>
                    <mat-grid-tile>
                        <div class="w-100">
                            <mat-form-field appearance="outline" class="form-feild">
                                <mat-label>Device Name </mat-label>
                                <input matInput placeholder="Device Name" formControlName="deviceName" />
                                <mat-error *ngIf="deviceInputForm.invalid">
                                    {{errorMessageFormField.deviceName}}
                                </mat-error>
                            </mat-form-field>
                        </div>
                    </mat-grid-tile>
                    <mat-grid-tile>
                        <div class="w-100">
                            <mat-form-field appearance="outline" class="form-feild">
                                <mat-label>Port Number </mat-label>
                                <input matInput placeholder="Port Number" formControlName="portNumber" type="number" />
                                <mat-error *ngIf="deviceInputForm.invalid">
                                    {{errorMessageFormField.portNumber}}
                                </mat-error>
                            </mat-form-field>
                        </div>
                    </mat-grid-tile>
                </mat-grid-list>
                <!-- <div class="nots-text">
                    <span>Note: Changes in parameter value needs server restart.</span>
                </div> -->
            </div>
        </mat-dialog-content>
        <mat-dialog-actions align="end">
            <button mat-stroked-button type="submit" *ngIf="isAddButton" class="add-btn"
                (click)="addDevice()">Add</button>
            <button mat-stroked-button type="submit" *ngIf="!isAddButton" class="update-btn"
                (click)="updateDevice()">Update</button>
            <button mat-stroked-button [mat-dialog-close]="true">Close</button>
        </mat-dialog-actions>
    </form>
</div>